import { Outlet } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export function Component() {
    return (
        <Outlet />
    );
}

Component.displayName = 'App';
